import { YoUser } from '../../types';
import { DocMapping } from './doc-mapping';

export const MapDocToUser: DocMapping<YoUser> = (id, data) => {
  return { ...{ email: id }, ...data } as YoUser;
};
